/**
 * Remove non printable ascii characters (chars not between the space and the tilde are removed)
 * @param str String to be cleaned
 * @returns String without whitespaces and unprintable ascii characters
 */
export const removeNonPrintableChars = (str: string) =>
  str.replace(/[^ -~]+/g, '').trim();
